
import { useCallback, useEffect, useRef, useState } from 'react';
import { Breadcrumb, Button, Card, Drawer, Input, List, Modal, Popconfirm, Space, Spin, Upload, message } from 'antd';
import { GetImageFolderList, DelImage, CreateFolder, DelFolder, UploadImage } from "../Service/MediaMakerService";
import { useRequest } from "ahooks";
import { CloseOutlined, FolderAddOutlined, FolderOpenOutlined, DeleteOutlined, FundViewOutlined, PlusOutlined } from "@ant-design/icons";
import Meta from 'antd/lib/card/Meta';
import moment from 'moment';
import { useEditorContext } from '../EditorContext';
import './ListWithDragger.css';


const { Search } = Input;


const FileManager = () => {
  const [folderVisible, setFolderVisible] = useState(false);
  const folderInputRef = useRef(null);
  const [searchKey, setSearchKey] = useState("");
  const [currentSearchKey, setCurrentSearchKey] = useState("");
  const { shareRefs } = useEditorContext();
  const localFileKey = localStorage.getItem("fileKey");
  const firstFileKey = localFileKey? localFileKey: process.env.REACT_APP_FILE_KEY;
  const [folderPath, setFolderPath] = useState(firstFileKey);
  const [visible, setVisible] = useState(false);

  const [isDragging, setIsDragging] = useState(false); // 用于跟踪是否在拖拽状态
  const [isUploading, setIsUploading] = useState(false);

  const triggerFileManger = useCallback((visible) => {
    setVisible(visible)
  }, [setVisible]);

  useEffect(() => {
    shareRefs.triggerFileManger = triggerFileManger;
  }, []);

  const [currentPage, setCurrentPage] = useState(1);

  const { data: imageListData, run: runGetImageFolderList, loading: getImageFolderListLoading } = useRequest(GetImageFolderList, {
    manual: true, 
  })

  useEffect(() => {
    if (firstFileKey){
      setFolderPath(firstFileKey);
    }
  }, [firstFileKey]);

  useEffect(() => {
    setCurrentPage(1);
    setSearchKey("");
    setCurrentSearchKey("");
    runGetImageFolderList(folderPath);
  }, [folderPath]);


  const { run: runUploadImage } = useRequest(UploadImage, {
    manual: true, 
    onSuccess: ()=>{
      runGetImageFolderList(folderPath, searchKey);
      setIsUploading(false);
    },
    onError: (err)=>{
      message.error(err.message);
      setIsUploading(false);
    }
  })

  const { run: runDelImage } = useRequest(DelImage, {
    manual: true, 
    onSuccess: ()=>{
      runGetImageFolderList(folderPath, searchKey);
    },
    onError: (err)=>{
      message.error(err.message);
    }
  })

  const { run: runDelFolder } = useRequest(DelFolder, {
    manual: true, 
    onSuccess: ()=>{
      runGetImageFolderList(folderPath, searchKey);
    },
    onError: (err)=>{
      message.error(err.message);
    }
  })

  const { run: runCreateFolder } = useRequest(CreateFolder, {
    manual: true, 
    onSuccess: ()=>{
      setFolderVisible(false);
      runGetImageFolderList(folderPath, searchKey);
    },
    onError: (err)=>{
      message.error(err.message);
    }
  })
  return (
    <>
    <div >
      <Drawer
        visible={visible}
        onClose={()=>setVisible(false)}
        height={"100%"}
        placement="bottom"
        closeIcon={
          <Button type="link">
            <CloseOutlined style={{ fontSize: 20, color: 'black' }} />
          </Button>}
        extra={
          <div style={{ justifyContent: 'space-between', width: "100%", minWidth: "850px", textAlign: 'right' }}>
          <Space style={{ margin: "16px 100px" }}>
            <Breadcrumb>
              {<>{folderPath.split('/')?.map((_, index)=>folderPath.split('/').slice(0, index+1).join("/"))?.map((item, index)=>(
                <Breadcrumb.Item key={index} onClick={()=>setFolderPath(item)}><a target="_blank">{index===0 ? "Home" : item.split("/")[item.split("/").length-1]}</a></Breadcrumb.Item>
              ))}</>}
            </Breadcrumb>
          </Space>
          <Space>
            <Search placeholder="Search in folder" value={currentSearchKey} onChange={(e) => setCurrentSearchKey(e.target.value)} 
            onSearch={(key)=>{
              setCurrentPage(1);
              setSearchKey(key);
              runGetImageFolderList(folderPath, key);
              }} style={{ width: 200 }} />
            <Button type="default" icon={<FolderAddOutlined />} onClick={()=>{setFolderVisible(true)}}></Button>
            <Modal
              visible={folderVisible}
              style={{ zIndex: 1000}}
              title="Create Folder"
              onCancel={()=>setFolderVisible(false)}
              footer={[
                <Button key="cancel" onClick={()=>setFolderVisible(false)}>
                  Cancel
                </Button>,
                <Button key="create" type="primary" onClick={()=>{
                  const folderName = folderInputRef?.current?.input?.value;
                  if (!folderName || folderName.trim() === "") {
                    message.error("The folder name cannot be empty.");
                    return;
                  }
                  runCreateFolder({
                    "folder_name": folderName,
                    "file_key": folderPath
                  });
                  }}>
                  Confirm
                </Button>,
              ]}
              >
            <Input
              placeholder="Please input folder name"
              maxLength={70}
              ref={folderInputRef}
            />
            </Modal>
            <Upload
              accept=".png, .jpeg, .jpg"
              multiple
              customRequest={(option: any)=>{
                const file = option.file as File;
                let formData = new FormData();
                formData.append("file", file);
                formData.append("file_key", folderPath);
                runUploadImage(formData);
                setIsUploading(true);
              }}
              showUploadList={false}
            >
              <Button type="primary" >Upload</Button>
            </Upload>
          </Space>
          </div>
        }
      >
        {getImageFolderListLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Spin />
          </div>
        ): (
          isUploading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <Spin />
            </div>
          ): (
          <div
            className={`${isDragging ? 'drag-over' : ''}`}
            style={{ width: "100%", height: "100%", padding: '2px' }}
            onDrop={(e)=>{
              e.preventDefault();
              e.stopPropagation()
              
              const files = [...e.dataTransfer.files];
              // const items = [...e.dataTransfer.items];
              let formData = new FormData();
              formData.append("file", files[0]);
              formData.append("file_key", folderPath);
              runUploadImage(formData);

              setIsDragging(false);
              setIsUploading(true);
            }}
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsDragging(true);
            }}
            onDragEnter={(e)=>{
              e.preventDefault();
              e.stopPropagation();
              setIsDragging(true);
            }}
            onDragLeave={(e)=>{
              e.preventDefault();
              e.stopPropagation();
              setIsDragging(false);
            }}
          >
            <List
            grid={{ gutter: 17, column: 5 }}
            size='small'
            dataSource={imageListData?.data}
            renderItem={(item, index) => (
              <List.Item>
                {item.file_type==="folder" ? (
                  <Card style={{ height: "360px" }}
                    cover={
                      <div style={{ height: "200px", background: "#f0f0f0", display: "flex", justifyContent: "center", alignItems: "center" }} onClick={()=>{
                        setFolderPath(`${folderPath}/${item.file_name}`);
                        }} >
                        <FolderOpenOutlined style={{ fontSize: "90px" }} />
                      </div>
                    }
                    actions={[
                      <Popconfirm
                        title="Are you sure to delete this file?"
                        onConfirm={()=>{
                          runDelFolder(`${folderPath}/${item.file_name}`);
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                      <DeleteOutlined key="delete" />
                      </Popconfirm>
                    ]}
                  >
                    <Meta
                      style={{ height: "50px" }}
                      title={item.file_name}
                    />
                    {/* <p>Create Time: {moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</p> */}
                  </Card>
                ): (
                  <Card style={{ height: "360px" }}
                    cover={
                      <div style={{ height: "200px", background: "#f0f0f0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={item.thumbnail ? item.thumbnail.file_link :item.file_link } alt={`Image ${index}`} style={{ maxWidth: "100%", maxHeight: "100%", width: "90%" }} />
                      </div>
                    }
                    actions={[
                      <FundViewOutlined key="preview"
                        onClick={()=>window.open(item.file_link, '_blank')}
                      />,
                      <Popconfirm
                        title="Are you sure to delete this file?"
                        onConfirm={()=>{
                          runDelImage(`${folderPath}/${item.file_name}`);
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                      <DeleteOutlined key="delete" /></Popconfirm>,
                      <PlusOutlined key="insert" 
                        onClick={()=>{
                          shareRefs.handleInsertPath(item.file_link);
                          setVisible(false);
                        }}
                      />
                    ]}
                  >
                    <Meta
                      style={{ height: item?.created_at ? "25px": "50px" }}
                      title={item.file_name}
                    />
                    {item?.created_at && <p>Create Time: {moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</p>}
                  </Card>
                )}
              </List.Item>
            )}
            pagination={{
              current: currentPage,
              defaultPageSize: 20,
              total: imageListData?.total,
              onChange: (page) => {
                setCurrentPage(page);
              }
            }}
          >
            </List>
          </div>
        )
        )}
      </Drawer>
    </div>
    </>
  );
};

export default FileManager;


